import { AccumulationLimitType } from "generated-graphql/graphql";
import { deriveRuleSource } from "routes/Customer/Waste/Containers/clockRuleSource";

type ClockSlot = {
  limitType: AccumulationLimitType;
  jurisdiction: string;
  citation: string;
  days?: number | null;
};

type CapsSlot = {
  limitType: AccumulationLimitType;
  jurisdiction: string;
  citation: string;
  nonAcuteGal?: number | null;
  acuteGal?: number | null;
  acuteKg?: number | null;
  moveWindowDays?: number | null;
};

/** One display line for the clock (time-limit) axis of a ruleset. */
export function formatClockSlotLine(slot: ClockSlot): string {
  if (slot.limitType === AccumulationLimitType.None) {
    return `No standing limit — ${slot.citation}`;
  }
  const source = deriveRuleSource(slot);
  if (slot.days == null) {
    return `${slot.citation} (${source.label})`;
  }
  return `${slot.days} days — ${slot.citation} (${source.label})`;
}

/** One display line for the caps (volume-limit) axis of a ruleset. */
export function formatCapsSlotLine(slot: CapsSlot): string {
  if (slot.limitType === AccumulationLimitType.None) {
    return `No standing limit — ${slot.citation}`;
  }
  const source = deriveRuleSource(slot);
  const thresholds = [
    slot.nonAcuteGal != null ? `${slot.nonAcuteGal} gal non-acute` : null,
    slot.acuteGal != null ? `${slot.acuteGal} gal acute` : null,
    slot.acuteKg != null ? `${slot.acuteKg} kg acute` : null,
  ]
    .filter((part): part is string => part !== null)
    .join(" / ");
  const moveWindow = slot.moveWindowDays != null ? `, move within ${slot.moveWindowDays} days` : "";
  const thresholdPrefix = thresholds ? `${thresholds} — ` : "";
  return `${thresholdPrefix}${slot.citation} (${source.label})${moveWindow}`;
}
